export default class EmailFormatRule {
    constructor(options = {}) {
        const t = options.translator;
        if (!t) {
            throw new Error('translator option is required in EmailFormatRule');
        }
        this.messages = {
            emailFormat: t('validation/email-format'),
            ...options.messages,
        };
    }

    isValid = value => {
        const mailformat = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

        if (value.match(mailformat)) {
            return true;
        }
        return false;
    };

    getErrorMsg() {
        return this.messages.emailFormat;
    }
}
